import { API_URL } from '../config';
import { deleteData, getData, postData, putResponse } from './http';

export const getCurrentUser = async () => getData(`${API_URL}/users/current_user_info`);

export const getUsers = async (page = 1, rowsPerPage, filters = {}, sortField, sortOrder, disabledUsers, brand_id) => {
  return getData(`${API_URL}/users`, {
    params: {
      page,
      per_page: rowsPerPage,
      ...filters,
      sort_field: sortField,
      sort_order: sortOrder,
      obsolete: disabledUsers,
      brand_id,
    },
  });
};

export const getBonusUsers = async () => {
  const data = await getData(`${API_URL}/users/bonus_users`);
  return data.users;
};

export const exportUsers = async () => getData(`${API_URL}/users/export`);

export const disableUser = async (id) => deleteData(`${API_URL}/users/${id}`);

export const getUser = async (id) => getData(`${API_URL}/users/${id}`);

export const getUserEdit = async (id) => getData(`${API_URL}/users/${id}/edit`);

export const updateUser = async (id, user) => {
  try {
    const response = await putResponse(`${API_URL}/users/${id}`, user);
    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const newQrCode = async () => getData(`${API_URL}/users/new_qr`);

export const roleExists = async (roles, user) => {
  return getData(`${API_URL}/users/check_for_existing_roles`, {
    params: {
      roles,
      id: user,
    },
  });
};

export const roleExistsNewUser = async (roles) => {
  return getData(`${API_URL}/users/check_for_existing_roles_new_user`, {
    params: {
      roles,
    },
  });
};

export const createUser = async (user) => {
  try {
    return await postData(`${API_URL}/users`, user);
  } catch (error) {
    return error.response?.data || { message: error.message, status: 500 };
  }
};

export const roleChecks = async () => getData(`${API_URL}/role_checks`);

export const checkEmail = async (email, id) => {
  return getData(`${API_URL}/users/check_email`, {
    params: {
      email,
      id,
    },
  });
};
